import { render } from "./LeaveRequests.vue?vue&type=template&id=704f8dd0"
import script from "./LeaveRequests.vue?vue&type=script&lang=js"
export * from "./LeaveRequests.vue?vue&type=script&lang=js"

import "./LeaveRequests.vue?vue&type=style&index=0&id=704f8dd0&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__